var _path, _path2, _path3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnBgHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 235,
    height: 55,
    viewBox: "0 0 235 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.031 9C233.031 4.58172 229.45 1 225.031 1H9.03125C4.61298 1 1.03125 4.58172 1.03125 9V46C1.03125 50.4183 4.61297 54 9.03125 54H225.031C229.45 54 233.031 50.4183 233.031 46L233.031 9Z",
    fill: "url(#paint0_linear_19_23)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03125 0.5H225.031C229.726 0.5 233.531 4.30558 233.531 9L233.531 46C233.531 50.6944 229.726 54.5 225.031 54.5H9.03125C4.33682 54.5 0.53125 50.6944 0.53125 46V9C0.53125 4.30558 4.33684 0.5 9.03125 0.5Z",
    stroke: "url(#paint1_linear_19_23)",
    strokeOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03125 0.5H225.031C229.726 0.5 233.531 4.30558 233.531 9L233.531 46C233.531 50.6944 229.726 54.5 225.031 54.5H9.03125C4.33682 54.5 0.53125 50.6944 0.53125 46V9C0.53125 4.30558 4.33684 0.5 9.03125 0.5Z",
    stroke: "url(#paint2_linear_19_23)",
    strokeOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.476 20.6664L207.779 25.9697C208.072 26.2625 208.072 26.7375 207.779 27.0303L202.476 32.3336C202.183 32.6264 201.708 32.6264 201.415 32.3336C201.122 32.0409 201.122 31.5658 201.415 31.273L205.438 27.2499L193.814 27.2499C193.4 27.2499 193.064 26.9143 193.064 26.5C193.064 26.0857 193.4 25.7501 193.814 25.7501L205.438 25.7501L201.415 21.727C201.122 21.4342 201.122 20.9591 201.415 20.6664C201.708 20.3736 202.183 20.3736 202.476 20.6664Z",
    fill: "#91E2EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_23",
    x: 181.064,
    y: 8.44678,
    width: 38.9349,
    height: 36.1064,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.643137 0 0 0 0 0.964706 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_23"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_23",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_23",
    x1: 209.064,
    y1: 82.5385,
    x2: 32.5464,
    y2: -11.1437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19_23",
    x1: 117.031,
    y1: 1,
    x2: 117.031,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19_23",
    x1: 117.031,
    y1: 7,
    x2: 117.031,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3F5FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3F5FE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnBgHover);
export default __webpack_public_path__ + "static/media/btn-bg-hover.0db37462.svg";
export { ForwardRef as ReactComponent };